import React, { useEffect, useState, useRef } from "react";
import API from "../../../services";
import { connect } from "react-redux";
import { RootState } from "../../../models/RootState";
import "./BetList.scss";
import { useNavigate } from "react-router";
import TokenPagination from "../TokenPagination";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Loader } from "../../../constants/whitelabelEnv";
import { domain } from "../../../constants/Branding";
import { useTranslation } from "../../../hooks/useTranslation";
interface CustomerSupportProps {
    userDetails?: any;
    dynamicTextColors?: any;
}



const BetList: React.FC<CustomerSupportProps> = ({ userDetails, dynamicTextColors }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [tickets, setTickets] = useState<any>([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const navigate = useNavigate();
    const [nextPageToken, setNextPageToken] = useState("");
    const [pageTokenHistory, setPageTokenHistory] = useState<string[]>([""]);

    // Get dynamic text color classes from Redux instead of calling function
    const textColorClass = dynamicTextColors?.pageTextColorClass || '';
    const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';



    const dateFormat = (time: any) => {
        const matchStartTime = new Date(time);

        const formattedStartTime = matchStartTime.toLocaleString("en-GB", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
        });

        return formattedStartTime
    }


    const isFirstRender = useRef(true);

    const resetPagination = () => {
        setPageTokenHistory([""]);
        setNextPageToken("");
    };

    const getBetList = async (pageToken = "") => {
        if (isFirstRender.current) {
            setLoading(true);
            isFirstRender.current = false;
        }

        let response;
        try {
            response = await API.post(`/users/bet-list`, {
                pageToken,
                pageSize: rowsPerPage,
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            navigate("/home");
        }

        if (response && response.data?.bets) {
            setTickets(response?.data?.bets);
            setNextPageToken(response?.data?.nextPageToken || "");
        }
        setLoading(false);
    };

    const handleNextPage = () => {
        if (!nextPageToken) return;
        setPageTokenHistory((prev) => [...prev, nextPageToken]);
        getBetList(nextPageToken);
    };

    const handlePrevPage = () => {
        if (pageTokenHistory.length <= 1) return;
        const updatedHistory = pageTokenHistory.slice(0, -1);
        const previousToken = updatedHistory[updatedHistory.length - 1] || "";
        setPageTokenHistory(updatedHistory);
        getBetList(previousToken);
    };

    const handleRowsPerPageChange = () => {
        resetPagination();
        isFirstRender.current = true;
        getBetList("");
    };

    useEffect(() => {
        getBetList("");
    }, [])

    const copyToClipboard = (text: any) => {
        navigator?.clipboard?.writeText(text)?.then(() => {
        });
    }

    const handleRowClick = (row: any) => {
        navigate("/bet-details", { state: { details: row } });
    };

    const handleBackClick = () => {
        navigate(-1);
    };


    return (
        <>
            <div className={`flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] bet-list ${textColorClass}`}>
                {
                    loading ? (
                        <div className="home-loading">
                            <img src={Loader(domain)} style={{ height: '10rem' }} />
                        </div>
                    ) : (
                        <>
                            <header className={`flex gap-3 items-center self-start text-base font-medium text-center mb-[0.5rem] ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                            <div>
                                <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                                    onClick={() => handleBackClick()}
                                >
                                    <ArrowBackIcon
                                        className={`aspect-square w-[18px] ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        style={{ width: '20px', height: '20px' }}
                                    />
                                </div>
                            </div>
                                <h2 className="self-stretch my-auto">{t("bets.betList")}</h2>
                            </header>
                            <div className="overflow-x-auto">
                                <table className="min-w-full border-collapse user-table border-x mt-1">
                                    <thead>
                                        <tr>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.betId")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.category")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.status")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.profitLoss")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.date")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("common.playChips")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("common.points")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("common.reward")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.eventName")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.marketName")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.marketType")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.runnerName")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.betType")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.oddValue")}</th>
                                            <th className={`px-4 py-2 text-left border-b border-t ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{t("bets.sportName")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tickets.map((row: any, index: number) => {
                                            const profitLossAmount = row?.walletType === "REWARD"
                                                ? row?.rewardNetAmount
                                                : row?.netAmout;

                                            return (
                                            <tr key={index} className="border-b"
                                                onClick={() => handleRowClick(row)}
                                            >
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                                    <div className="flex">
                                                        <span
                                                            className="truncate max-w-[140px]"
                                                            title={row?.betId}
                                                        >
                                                            {row?.betId}
                                                        </span>
                                                        <ContentCopyIcon
                                                            className={`cursor-pointer ml-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                                            onClick={() => copyToClipboard(row?.betId)}
                                                            titleAccess={t("bets.copyToClipboard")}
                                                            style={{ height: "1rem" }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.category}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                                    {row?.status}
                                                </td>
                                                <td
                                                    className={`p-2 ${profitLossAmount > 0
                                                        ? 'text-green-500'
                                                        : profitLossAmount < 0
                                                            ? 'text-red-500'
                                                            : textColorClass === 'dark-text' ? 'text-black' : 'text-white'
                                                        }`}
                                                >
                                                    {profitLossAmount
                                                        ? profitLossAmount % 1 === 0
                                                            ? profitLossAmount
                                                            : profitLossAmount.toFixed(2)
                                                        : 0}
                                                </td>
                                                <td className={`px-2 py-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                                    {dateFormat(row?.betTime)}
                                                </td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.playChips}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.points}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.reward}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.eventName}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.marketName}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.marketType}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.runnerName}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.betType}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.oddValue}</td>
                                                <td className={`p-2 ${textColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{row?.sportName}</td>
                                            </tr>
                                        )})}
                                    </tbody>
                                </table>

                            </div>
                            <TokenPagination
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                onNext={handleNextPage}
                                onPrev={handlePrevPage}
                                canGoPrev={pageTokenHistory.length > 1}
                                canGoNext={!!nextPageToken}
                                onRowsPerPageChange={handleRowsPerPageChange}
                               
                            />
                        </>
                    )
                }
            </div>
        </>
    );
};



const mapStateToProps = (state: RootState) => {
    return {
        userDetails: state.userDetails?.userDetails,
        dynamicTextColors: state.userDetails?.dynamicTextColors,
    };
};

export default connect(mapStateToProps)(BetList);
